"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateELMJSONFunction = exports.setValueSetVersionsToUndefined = exports.createEpisodePopulationValues = exports.createPatientPopulationValues = exports.handlePopulationValues = exports.createPopulationValues = void 0;
var MeasureBundleHelpers = __importStar(require("../helpers/MeasureBundleHelpers"));
var ClauseResultsBuilder_1 = require("./ClauseResultsBuilder");
var Enums_1 = require("../types/Enums");
/**
 * Create population values (aka results) for all populations in the population group using the results from the
 * calculator. This creates the DetailedPopulationGroupResult for the patient that will be filed my most of the
 * results processing functions.
 *
 * @param {fhir4.Measure} measure - The measure we are getting the values for.
 * @param {fhir4.MeasureGroup} populationGroup - The population group that we are creating results to.
 * @param {cql.StatementResults} patientResults - The raw results object from the calculation engine for a patient.
 * @returns {DetailedPopulationGroupResult} The population group results object with the populationResults, stratifierResults,
 *   and episodeResults (if episode of care measure) populated.
 */
function createPopulationValues(measure, populationGroup, patientResults) {
    var populationResults = [];
    var stratifierResults;
    var episodeResults;
    // patient based measure
    if (!MeasureBundleHelpers.isEpisodeOfCareMeasure(measure)) {
        var popAndStratResults = createPatientPopulationValues(populationGroup, patientResults);
        populationResults = popAndStratResults.populationResults;
        stratifierResults = popAndStratResults.stratifierResults;
        populationResults = handlePopulationValues(populationResults);
    }
    else {
        // episode of care based measure
        // collect results per episode
        episodeResults = createEpisodePopulationValues(populationGroup, patientResults);
        // if no episodes were found we need default populationResults/stratifier results. just use the patient
        // level logic for this
        if (episodeResults == undefined || episodeResults.length == 0) {
            episodeResults = [];
            var popAndStratResults = createPatientPopulationValues(populationGroup, patientResults);
            populationResults = popAndStratResults.populationResults;
            stratifierResults = popAndStratResults.stratifierResults;
        }
        else {
            populationResults = [];
            stratifierResults = [];
            // create patient level population and stratifier results based on episodes
            episodeResults.forEach(function (episodeResult) {
                var _a;
                episodeResult.populationResults.forEach(function (popResult) {
                    ClauseResultsBuilder_1.createOrSetResult(popResult.populationType, popResult.result, populationResults);
                });
                (_a = episodeResult.stratifierResults) === null || _a === void 0 ? void 0 : _a.forEach(function (strat) {
                    var stratRes = stratifierResults === null || stratifierResults === void 0 ? void 0 : stratifierResults.find(function (stratRes) { return stratRes.strataCode === strat.strataCode; });
                    if (stratRes) {
                        if (strat.result === true) {
                            stratRes.result = true;
                        }
                    }
                    else {
                        stratifierResults === null || stratifierResults === void 0 ? void 0 : stratifierResults.push({
                            result: strat.result,
                            strataCode: strat.strataCode
                        });
                    }
                });
            });
        }
    }
    var detailedResult = {
        groupId: populationGroup.id || 'unknown',
        statementResults: [],
        populationResults: populationResults,
        episodeResults: episodeResults,
        stratifierResults: stratifierResults
    };
    return detailedResult;
}
exports.createPopulationValues = createPopulationValues;
/**
 * Takes in the initial values from the population and checks to see if some values should not be calculated. These
 * values that should not be considered calculated are zeroed out. ex. results NUMER is true but IPP is false.
 * @param {PopulationResult[]} populationResults - The list of population results.
 * @returns {PopulationResult[]} Population results in the list as passed in, but the appropiate values are zeroed out.
 */
function handlePopulationValues(populationResults) {
    /* Setting values of populations if the correct populations are not set based on the following logic guidelines
     * Initial Population (IPP): The set of patients or episodes of care to be evaluated by the measure.
     * Denominator (DENOM): A subset of the IPP.
     * Denominator Exclusions (DENEX): A subset of the Denominator that should not be considered for inclusion in the Numerator.
     * Denominator Exceptions (DEXCEP): A subset of the Denominator. Only those members of the Denominator that are considered
     * for Numerator membership and are not included are considered for membership in the Denominator Exceptions.
     * Numerator (NUMER): A subset of the Denominator. The Numerator criteria are the processes or outcomes expected for each patient,
     * procedure, or other unit of measurement defined in the Denominator.
     * Numerator Exclusions (NUMEX): A subset of the Numerator that should not be considered for calculation.
     * Measure Poplation Exclusions (MSRPOPLEX): Identify that subset of the MSRPOPL that meet the MSRPOPLEX criteria.
     */
    var populationResultsHandled = populationResults;
    // Cannot be in all populations if not in IPP.
    if (!ClauseResultsBuilder_1.getResult(Enums_1.PopulationType.IPP, populationResults)) {
        populationResults.forEach(function (result) {
            if (result.populationType == Enums_1.PopulationType.OBSERV) {
                result.observations = null;
            }
            result.result = false;
        });
        // Cannot be in most populations if not in DENOM or MSRPOPL
    }
    else if ((ClauseResultsBuilder_1.hasResult(Enums_1.PopulationType.DENOM, populationResults) && !ClauseResultsBuilder_1.getResult(Enums_1.PopulationType.DENOM, populationResults)) ||
        (ClauseResultsBuilder_1.hasResult(Enums_1.PopulationType.MSRPOPL, populationResults) && !ClauseResultsBuilder_1.getResult(Enums_1.PopulationType.MSRPOPL, populationResults))) {
        ClauseResultsBuilder_1.setResult(Enums_1.PopulationType.DENEX, false, populationResults);
        ClauseResultsBuilder_1.setResult(Enums_1.PopulationType.DENEXCEP, false, populationResults);
        ClauseResultsBuilder_1.setResult(Enums_1.PopulationType.NUMER, false, populationResults);
        ClauseResultsBuilder_1.setResult(Enums_1.PopulationType.NUMEX, false, populationResults);
        ClauseResultsBuilder_1.setResult(Enums_1.PopulationType.MSRPOPLEX, false, populationResults);
        var popResult = populationResults.find(function (result) { return result.populationType == Enums_1.PopulationType.OBSERV; });
        if (popResult) {
            popResult.result = false;
            popResult.observations = null;
        }
        // Cannot be in the numerator if they are excluded from the denominator
    }
    else if (ClauseResultsBuilder_1.getResult(Enums_1.PopulationType.DENEX, populationResults)) {
        ClauseResultsBuilder_1.setResult(Enums_1.PopulationType.NUMER, false, populationResults);
        ClauseResultsBuilder_1.setResult(Enums_1.PopulationType.NUMEX, false, populationResults);
        ClauseResultsBuilder_1.setResult(Enums_1.PopulationType.DENEXCEP, false, populationResults);
        // Cannot have observations if in the MSRPOPLEX
    }
    else if (ClauseResultsBuilder_1.getResult(Enums_1.PopulationType.MSRPOPLEX, populationResults)) {
        var popResult = populationResults.find(function (result) { return result.populationType == Enums_1.PopulationType.OBSERV; });
        if (popResult) {
            popResult.result = false;
            popResult.observations = null;
        }
        // Cannot be in the NUMEX if not in the NUMER
    }
    else if (!ClauseResultsBuilder_1.getResult(Enums_1.PopulationType.NUMER, populationResults)) {
        ClauseResultsBuilder_1.setResult(Enums_1.PopulationType.NUMEX, false, populationResults);
        // Cannot be in the DENEXCEP if in the NUMER
    }
    else if (ClauseResultsBuilder_1.getResult(Enums_1.PopulationType.NUMER, populationResults)) {
        ClauseResultsBuilder_1.setResult(Enums_1.PopulationType.DENEXCEP, false, populationResults);
    }
    return populationResultsHandled;
}
exports.handlePopulationValues = handlePopulationValues;
/**
 * Create patient population values (aka results) for all populations in the population group using the results from the
 * calculator.
 * @param {fhir4.MeasureGroup} populationGroup - The population group we are getting the values for.
 * @param {cql.StatementResults} patientResults - The raw results object for a patient from the calculation engine.
 * @returns {PopulationResult[]} The population results list.
 */
function createPatientPopulationValues(populationGroup, patientResults) {
    var _a;
    var populationResults = [];
    // Loop over all populations ("IPP", "DENOM", etc.)
    (_a = populationGroup.population) === null || _a === void 0 ? void 0 : _a.forEach(function (population) {
        var cqlPopulation = population.criteria.expression;
        // Is there a patient result for this population? and does this populationCriteria contain the population
        // We need to check if the populationCriteria contains the population so that a STRAT is not set to zero if there is not a STRAT in the populationCriteria
        // Grab CQL result value and adjust for ECQME
        var populationType = MeasureBundleHelpers.codeableConceptToPopulationType(population.code);
        // If this is a valid population type and there is a defined cql population pull out the values
        if (populationType != null && cqlPopulation != null) {
            var value = patientResults[cqlPopulation];
            var result = isStatementValueTruthy(value);
            var newPopulationResult = {
                populationType: populationType,
                result: result
            };
            populationResults.push(newPopulationResult);
        }
    });
    // Loop over all stratifiers if there are any an collect results
    var stratifierResults;
    if (populationGroup.stratifier) {
        stratifierResults = [];
        // index used incase the text for the stratifier could not be found
        var strataIndex_1 = 1;
        populationGroup.stratifier.forEach(function (strata) {
            var _a, _b, _c, _d;
            if ((_a = strata.criteria) === null || _a === void 0 ? void 0 : _a.expression) {
                var value = patientResults[(_b = strata.criteria) === null || _b === void 0 ? void 0 : _b.expression];
                var result = isStatementValueTruthy(value);
                stratifierResults === null || stratifierResults === void 0 ? void 0 : stratifierResults.push({
                    strataCode: (_d = (_c = strata.code) === null || _c === void 0 ? void 0 : _c.text) !== null && _d !== void 0 ? _d : "strata-" + strataIndex_1++,
                    result: result
                });
            }
        });
    }
    //TODO: Support patient level observations.
    return {
        populationResults: populationResults,
        stratifierResults: stratifierResults
    };
}
exports.createPatientPopulationValues = createPatientPopulationValues;
function isStatementValueTruthy(value) {
    if (Array.isArray(value) && value.length > 0) {
        return true;
    }
    else if (typeof value === 'boolean' && value === true) {
        return true;
    }
    else {
        return false;
    }
}
/**
 * Create population results for all episodes using the results from the calculator. This is
 * used only for the episode of care measures.
 * @param {fhir4.MeasureGroup} populationGroup - The population group we are getting the values for.
 * @param {cql.StatementResults} patientResults - The raw results object for the patient from the calculation engine.
 * @returns {EpisodeResults[]} The episode results list. Structure with episode id population results for each episode.
 *   If this is a continuous variable measure the observations are included.
 */
function createEpisodePopulationValues(populationGroup, patientResults) {
    var _a, _b;
    var episodeResultsSet = [];
    (_a = populationGroup.population) === null || _a === void 0 ? void 0 : _a.forEach(function (population) {
        var _a;
        var cqlPopulation = population.criteria.expression;
        var populationType = MeasureBundleHelpers.codeableConceptToPopulationType(population.code);
        // If this is a valid population type and there is a defined cql population pull out the values
        if (populationType != null && cqlPopulation != null) {
            // handle observation population
            if (populationType === Enums_1.PopulationType.OBSERV) {
                // find the MSRPOPL for this population because we need to know its name
                var msrPopl = (_a = populationGroup.population) === null || _a === void 0 ? void 0 : _a.find(function (pop) { return MeasureBundleHelpers.codeableConceptToPopulationType(pop.code) === Enums_1.PopulationType.MSRPOPL; });
                if (msrPopl === null || msrPopl === void 0 ? void 0 : msrPopl.criteria.expression) {
                    var episodesRawResults = patientResults["obs_func_" + cqlPopulation + "_" + (msrPopl === null || msrPopl === void 0 ? void 0 : msrPopl.criteria.expression)];
                    // loop through observation results and create observations
                    if (Array.isArray(episodesRawResults)) {
                        episodesRawResults.forEach(function (rawEpisodeResult) {
                            var episodeId = rawEpisodeResult.episode.id.value;
                            var observation = rawEpisodeResult.observation;
                            // find existing episode result if any
                            var episodeResult = episodeResultsSet.find(function (episodeResult) { return episodeResult.episodeId === episodeId; });
                            if (!episodeResult) {
                                episodeResult = {
                                    episodeId: episodeId,
                                    populationResults: []
                                };
                                episodeResultsSet.push(episodeResult);
                            }
                            // if there already is a result for observation, add to the list
                            if (ClauseResultsBuilder_1.hasResult(Enums_1.PopulationType.OBSERV, episodeResult.populationResults)) {
                                var observResult = (episodeResult.populationResults.find(function (popResult) { return popResult.populationType === Enums_1.PopulationType.OBSERV; }));
                                if (!observResult.observations) {
                                    observResult.observations = [];
                                }
                                observResult.observations.push(observation);
                                observResult.result = true;
                            }
                            else {
                                episodeResult.populationResults.push({
                                    populationType: Enums_1.PopulationType.OBSERV,
                                    result: true,
                                    observations: [observation]
                                });
                            }
                        });
                    }
                }
            }
            else {
                // Handle non observation results.
                var rawEpisodeResults = patientResults[cqlPopulation];
                createOrSetValueOfEpisodes(rawEpisodeResults, episodeResultsSet, populationGroup, populationType);
            }
        }
        else {
            // TODO: Handle this situation of a malformed population
        }
    });
    // loop over stratifications and collect episode results for the strata
    var strataIndex = 1;
    (_b = populationGroup.stratifier) === null || _b === void 0 ? void 0 : _b.forEach(function (strata) {
        var _a, _b, _c, _d;
        var strataCode = (_b = (_a = strata.code) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : "strata-" + strataIndex++;
        if ((_c = strata.criteria) === null || _c === void 0 ? void 0 : _c.expression) {
            var rawEpisodeResults = patientResults[(_d = strata.criteria) === null || _d === void 0 ? void 0 : _d.expression];
            createOrSetValueOfEpisodes(rawEpisodeResults, episodeResultsSet, populationGroup, undefined, strataCode);
        }
    });
    // Correct any inconsistencies. ex. In DENEX but also in NUMER using same function used for patients.
    episodeResultsSet.forEach(function (episodeResults) {
        episodeResults.populationResults = handlePopulationValues(episodeResults.populationResults);
    });
    // TODO: Remove any episode that dont fall in any populations or stratifications after the above code
    return episodeResultsSet;
}
exports.createEpisodePopulationValues = createEpisodePopulationValues;
/**
 * Process the raw results from an episode of care population defining statement and fill or create the appropiate
 * entry in the episodeResultsSet
 *
 * @param {any} rawEpisodeResults - Raw population defining statement result. This result should be a list.
 * @param {EpisodeResults[]} episodeResultsSet - EpisodeResults set to populate.
 * @param {fhir4.MeasureGroup} populationGroup - The population group. Used to populate default values for a new encounter.
 * @param {PopulationType} populationType - If this is a regular population the type must be provided.
 * @param {string} strataCode - If this is a stratifier result, the code of the strata must be provided.
 */
function createOrSetValueOfEpisodes(rawEpisodeResults, episodeResultsSet, populationGroup, populationType, strataCode) {
    // Make sure the results are an array.
    if (Array.isArray(rawEpisodeResults)) {
        // Iterate over all episodes
        rawEpisodeResults.forEach(function (episodeResource) {
            var _a, _b;
            if (episodeResource.id.value != null) {
                // if an episode has already been created set the result for the population to true
                var episodeResults = episodeResultsSet.find(function (episodeResults) { return episodeResults.episodeId == episodeResource.id.value; });
                if (episodeResults) {
                    // set population value
                    if (populationType) {
                        ClauseResultsBuilder_1.setResult(populationType, true, episodeResults.populationResults);
                        // set strata value
                    }
                    else if (strataCode) {
                        if (episodeResults.stratifierResults) {
                            var strataResult = episodeResults.stratifierResults.find(function (strataResult) {
                                return strataResult.strataCode == strataCode;
                            });
                            if (strataResult) {
                                strataResult.result = true;
                            }
                        }
                    }
                    // else create a new episode using the list of all popcodes for the population
                }
                else {
                    var newEpisodeResults_1 = {
                        episodeId: episodeResource.id.value,
                        populationResults: []
                    };
                    (_a = populationGroup.population) === null || _a === void 0 ? void 0 : _a.forEach(function (population) {
                        newEpisodeResults_1.populationResults.push({
                            populationType: MeasureBundleHelpers.codeableConceptToPopulationType(population.code),
                            result: false
                        });
                    });
                    if (populationGroup.stratifier) {
                        newEpisodeResults_1.stratifierResults = [];
                        var strataIndex_2 = 1;
                        (_b = populationGroup.stratifier) === null || _b === void 0 ? void 0 : _b.forEach(function (strata) {
                            var _a, _b, _c;
                            var newStrataCode = (_b = (_a = strata.code) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : "strata-" + strataIndex_2++;
                            (_c = newEpisodeResults_1.stratifierResults) === null || _c === void 0 ? void 0 : _c.push({
                                strataCode: newStrataCode,
                                result: newStrataCode == strataCode ? true : false
                            });
                        });
                    }
                    // Set the result for the current episode to true
                    if (populationType) {
                        ClauseResultsBuilder_1.setResult(populationType, true, newEpisodeResults_1.populationResults);
                    }
                    episodeResultsSet.push(newEpisodeResults_1);
                }
            }
        });
    }
}
/**
 * Set all value set versions to 'undefined' so the execution engine does not grab the specified
 * version in the ELM
 *
 * @param elm List of elm libraries to remove valueSet versions from.
 * @returns The list passed in.
 */
function setValueSetVersionsToUndefined(elm) {
    elm.forEach(function (elmLibrary) {
        if (elmLibrary.library.valueSets != null) {
            elmLibrary.library.valueSets.def.forEach(function (valueSet) {
                if (valueSet.version != null) {
                    valueSet.version = undefined;
                }
            });
        }
    });
    return elm;
}
exports.setValueSetVersionsToUndefined = setValueSetVersionsToUndefined;
/**
 * Returns an ELM function to add to the ELM before it is used for calculation. This function is generated
 * for each observation on the measure. It returns a list of tuples, with each episode being observed and the
 * observation for the episode.
 *
 * @param {string} functionName - Name of the observation function. Usually "Measure Observation".
 * @param {string} parameter - Name of the define statement to use as the parameter list. Usually "Measure Population".
 * @returns {ELMStatement} The ELM function to inject into the ELM library before executing.
 */
function generateELMJSONFunction(functionName, parameter) {
    var elmFunction = {
        name: "obs_func_" + functionName + "_" + parameter,
        context: 'Patient',
        accessLevel: 'Public',
        expression: {
            type: 'Query',
            source: [
                {
                    alias: 'MP',
                    expression: {
                        name: parameter,
                        type: 'ExpressionRef'
                    }
                }
            ],
            relationship: [],
            return: {
                distinct: false,
                expression: {
                    type: 'Tuple',
                    element: [
                        {
                            name: 'episode',
                            value: {
                                name: 'MP',
                                type: 'AliasRef'
                            }
                        },
                        {
                            name: 'observation',
                            value: {
                                name: functionName,
                                type: 'FunctionRef',
                                operand: [
                                    {
                                        name: 'MP',
                                        type: 'AliasRef'
                                    }
                                ]
                            }
                        }
                    ]
                }
            }
        }
    };
    return elmFunction;
}
exports.generateELMJSONFunction = generateELMJSONFunction;
//# sourceMappingURL=DetailedResultsBuilder.js.map